module.exports = __webpack_public_path__ + "img/loadandtick.c81ecfd3.gif";